export const NetworkContextName = 'NETWORK';
export const ACTIVE_NETWORK = 42;
export const RPC_URL =
  'https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161';
export const TESTNFTAddress = '0x783957233f4Cc3D39Bff5BE162D6C5d113229670';
export const AdminWalletAddress = '0xE8C852FB61a6350caa4a5301ECaEa4F5DF2eAdE9';
